import { getAllCookies, deleteCookie, acceptingPerformanceCookies } from "$lib/utilities/cookies";
import { PRIVACY_MANDATE_REGIONS, REQUIRED_COOKIES } from "$lib/utilities/constants";

const defaultDataRedaction = true;

const consentTypes = [
  "ad_storage",
  "analytics_storage",
  "personalization_storage",
  "functionality_storage",
  "security_storage",
  "ad_user_data",
  "ad_personalization"
];

// Using the function keyword only for this function because, as someone pointed out before,
// this "truly does not work properly with rest params."
function gtag() {
  /* eslint-disable-next-line prefer-rest-params */
  window.dataLayer.push(arguments);
}

const deleteCookies = () => {
  Object.keys(getAllCookies()).forEach((cookie) => {
    if (!REQUIRED_COOKIES.includes(cookie)) {
      deleteCookie(cookie);
    }
  });
};

const buildConsentMap = (consentValue) => {
  return consentTypes.reduce((hash, elem) => {
    hash[elem] = consentValue;
    return hash;
  }, {});
};

export const handleGtagConsent = () => {
  if (acceptingPerformanceCookies()) {
    gtag("consent", "default", buildConsentMap("granted"));
  } else if (!acceptingPerformanceCookies()) {
    deleteCookies();
    let consentMap = buildConsentMap("denied");
    gtag("consent", "default", consentMap);
  } else {
    deleteCookies();
    //Deny all cookie storage types in regions where this is prohibited.
    let consentMap = buildConsentMap("denied");
    consentMap.region = PRIVACY_MANDATE_REGIONS;
    gtag("consent", "default", consentMap);
  }
};

//This component has some complexity meant to support more indepth information
//to be captured by the tag manager at a later date.
export const getScriptSrcFromInitGtm = () => {
  const getScriptSrcForGtm = (containerId, params) => {
    if (typeof containerId !== "string" || !containerId.length) {
      // eslint-disable-next-line no-console
      console.error("GTM container id variable is not a string or is empty");
      return;
    } else {
      let script = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
      if (params) {
        script += `&${params}`;
      }

      return script;
    }
  };

  try {
    window.dataLayer = window.dataLayer || [];

    handleGtagConsent();

    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js"
    });
    gtag("set", "url_passthrough", true);
    gtag("set", "ads_data_redaction", defaultDataRedaction);
    //If other items are needed for GTM later, we can add them here
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Google Tag Manager.", error);
  }

  return getScriptSrcForGtm;
};
